import styled from '@emotion/styled';
import { mediaQuery } from 'src/assets/media-query-config';
import { withConfig } from 'src/utils/withConfig';

export const LoginImageWrapper = styled('div', { label: 'LoginImageWrapper' })<{imgSrc: string}>`
    display: none;

    @media ${mediaQuery.tablet} {
        display: block;
        width: 50%;
        background-position: center center;
        background-size: cover;
        background-image: ${({ imgSrc }): string => `url(${imgSrc})`};
    }
`;

export const LoginImageWrapperWithBackground = withConfig(theme => styled('div', { label: 'LoginImageWrapperWithBackground' })<{imgSrc: string}>`
    display: none;

    @media ${mediaQuery.desktop} {
        display: block;
        width: 50%;

        background-repeat: no-repeat;
        background-position: right top;
        background-size: auto 100%;
        background-color: ${theme.loginPage.bgColor};

        background-image: ${({ imgSrc }): string => `url(${imgSrc})`};
    }
`);

